import { render, staticRenderFns } from "./img.vue?vue&type=template&id=684a6d66"
import script from "./img.vue?vue&type=script&lang=js"
export * from "./img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports